<template>
  <div :class="['collectionController', { isActive }]"
    @mouseleave="hideController">
    <div v-if="!isActive"
      class="collectionControllerTrigger"
      @mouseenter="showController">
    </div>
    <div class="collectionControllerBg"></div>

    <div class="collectionControllerInner">
      <div class="left">
        <button type="button" class="btn btnWhite btnRound sizeXs" @click="searchMode">
          검색모드
          <span>{{ isSearchMode ? 'OFF' : 'ON'}}</span>
        </button>
        <button type="button" class="btn btnWhite btnRound sizeXs" @click="fullScreen">
          전체화면
          <span>{{ isFullScreen ? 'OFF' : 'ON'}}</span>
        </button>
      </div>
      <div class="center">
        <button v-if="isMyCollection" type="button" class="btn btnWhite btnRound sizeXs" @click="getSnapshotList">
          마이콜렉션
          <span>내역</span>
        </button>
        <button v-if="isMyCollection && hasCollectionItemIds" type="button" class="btn btnRound sizeXs" @click="setSaveSnapshot">
          마이콜렉션
          <span>저장</span>
        </button>
      </div>
    </div>

    <div v-if="isMyCollection && showSnapshotMemo" class="layer snapshotLayer" @mouseenter.prevent.stop @mouseleave.prevent.stop>
      <div class="inner">
        <button type="button" class="btnClose" @click.stop="showSnapshotMemo = false"></button>
        <div class="layerTitle">메모를 입력해주세요.</div>
        <div class="snapshotMemoBox">
          <input type="text" ref="snapshotMemoInput" class="input" v-model="snapshotMemo" @keydown.enter.prevent.stop="saveSnapshot" />
          <button type="button" class="btn btnRound btnAuto" @click.prevent.stop="saveSnapshot">저장</button>
        </div>
      </div>
    </div>

    <MyCollectionSnapshot
      v-if="showSnapshotList"
      :locale="locale"
      :lang="lang"
      :pageId="pageId"
      :list="snapShotList"
      @close="closeSnapshot" />
  </div>
</template>

<script>
import MyCollectionSnapshot from './MyCollectionSnapshot'

export default {
  name: 'CollectionController',
  props: [
    'locale',
    'lang',
    'pageId',
    'isFullScreen',
    'isSearchMode',
    'isMyCollection'
  ],
  components: {
    MyCollectionSnapshot
  },
  computed: {
    isGroupCategory () {
      return this.$store.getters['collection/getMyCollectionIsGroupCategory']
    },
    hasCollectionItemIds () {
      const myCollectionItemIds = this.$store.getters['collection/getMyCollectionItemIds']
      return myCollectionItemIds && myCollectionItemIds.length > 0
    }
  },
  beforeDestroy () {
    if (this.hideTimer) clearTimeout(this.hideTimer)
  },
  data () {
    return {
      isSaveSnapshot: false,
      isActive: false,
      hideTimer: null,
      showSnapshotList: false,
      snapShotList: [],
      showSnapshotMemo: false,
      snapshotMemo: '',
    }
  },
  methods: {
    fullScreen () {
      this.$emit('fullScreen')
    },
    searchMode () {
      this.$emit('searchMode')
    },
    async getSnapshotList () {
      try {
        const pageId = this.$route.params.pageId
        const res = await this.$store.dispatch('collection/getMyCollectionSnapshot', pageId)
        if (res && res.snapShotList) {
          if (!res.snapShotList.length) {
            alert ('저장된 마이콜렉션 내역이 없습니다.')
            return
          }
          this.showSnapshotList = true
          this.snapShotList = res.snapShotList.sort((a, b) => new Date(b.createat) - new Date(a.createat))
        }
      } catch (err) {
        alert(err)
      }
    },
    async setSaveSnapshot (isForce) {
      if (!window.confirm('현재 마이콜렉션을 저장하시겠습니까?')) return
      this.showSnapshotMemo = true
      await this.$nextTick()
      if (this.$refs.snapshotMemoInput) {
        this.$refs.snapshotMemoInput.focus()
      }
    },
    async saveSnapshot () {
      if (this.isSaveSnapshot) return
      this.isSaveSnapshot = true
      try {
        const data = {
          pageId: this.$route.params.pageId,
          memo: this.snapshotMemo
        }
        const res = await this.$store.dispatch('collection/saveMyCollectionSnapshot', data)
        if (res && res.status === 200) {
          alert('마이콜렉션 내역이 저장되었습니다.')
          this.snapshotMemo = ''
          this.showSnapshotMemo = false
        }
      } catch (err) {
        alert(err)
      } finally {
        this.isSaveSnapshot = false
      }
    },
    closeSnapshot () {
      this.showSnapshotList = false
    },
    showController () {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer)
        this.hideTimer = null
      }
      this.isActive = true
    },
    hideController () {
      if (this.hideTimer) clearTimeout(this.hideTimer)

      this.hideTimer = setTimeout(() => {
        this.isActive = false
      }, 120)
    }
  }
}
</script>